module.exports = "# Paste or drop some GraphQL queries or schema\r\n# definitions here and explore the syntax tree\r\n# created by the GraphQL parser.\r\n\r\nquery GetUser($userId: ID!) {\r\n  user(id: $userId) {\r\n    id,\r\n    name,\r\n    isViewerFriend,\r\n    profilePicture(size: 50)  {\r\n      ...PictureFragment\r\n    }\r\n  }\r\n}\r\n\r\nfragment PictureFragment on Picture {\r\n  uri,\r\n  width,\r\n  height\r\n}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/graphql/codeExample.txt
 ** module id = ./src/parsers/graphql/codeExample.txt
 ** module chunks = 0
 **/